import { render, staticRenderFns } from "./QuizActivityOptions.vue?vue&type=template&id=6bbf8d0c&"
import script from "./QuizActivityOptions.vue?vue&type=script&lang=js&"
export * from "./QuizActivityOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports